import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Typography from '@material-ui/core/Typography';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

const Centered = styled.span`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0 16px;
`;

interface Props {
  open: boolean;
  handleClose: (done: boolean) => void;
  codCond: string;
  identidadeVisual: object;
}

export default ({ open, handleClose, codCond, identidadeVisual }: Props) => {
  const [block, setBlock] = useState(true);

  useEffect(() => {
    if (open) {
      setBlock(true);
    }
  }, [open]);

  return (
    <Dialog open={open} onClose={() => handleClose(false)}>
      <DialogTitle>
        <Centered>Termos de Uso</Centered>
      </DialogTitle>
      <DialogContent>
        <Typography style={{ marginBottom: '1rem' }}>
          Ao utilizar você aceita os termos de uso e declara:
        </Typography>
        <Typography style={{ marginBottom: '0.3rem' }}>
          Ser responsável pela Unidade selecionada, seja por propriedade ou
          instrumento de procuração, com poderes para representá-la na
          Assembleia do Condomínio, podendo votar e praticar todos os atos
          necessários ao bom e fiel cumprimento do presente mandato.
        </Typography>
        <Typography style={{ marginBottom: '0.3rem' }}>
          Esta plataforma pode armazenar cookies, dados de localização e seu
          endereço de IP para controles antifraudes.
        </Typography>
        <Typography style={{ marginBottom: '1rem' }}>
          E lembrando, caso esteja inadimplente seu voto terá peso zero.
        </Typography>
        {codCond == '2276' && (
          <>
            <Typography style={{ marginBottom: '0.3rem' }}>
              Neste ato, declaro estar ciente que todo o conteúdo desta
              Assembleia, assim como sua decisão, deve ser tratada de forma
              sigilosa, sem qualquer exposição dos funcionários do Condomínio,
              sendo proibida sua divulgação , propagação e exibição pública sem
              prévia autorização da Sindicância do Condomínio.
            </Typography>
            <Typography style={{ marginBottom: '0.3rem' }}>
              Outrossim, concordo através deste, e na melhor forma de direito,
              que os atos por ventura constatados serão considerados de minha
              inteira responsabilidade.
            </Typography>
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Centered>
          <FormControlLabel
            control={
              <Checkbox
                color="primary"
                style={{
                  color: identidadeVisual?.['headerColor'] || '#083F8B'
                }}
                checked={!block}
                onChange={() => setBlock(!block)}
              />
            }
            label="Eu li e concordo com os termos de uso."
          />
          <Button
            color="inherit"
            disabled={block}
            onClick={() => handleClose(!block)}
          >
            Continuar
          </Button>
        </Centered>
      </DialogActions>
    </Dialog>
  );
};
